import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { COLORS } from 'theme'
import YOEPercentageRangeSlider from '../../../../../../../components/YOEPercentageRangeSlider/Index'

export const StyledHeading = styled.h2`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  margin: 15px;
  color: ${props => (props.color ? props.color : COLORS.BLACK)};
`

export const StyledHeadingNew = styled.h2`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  margin: 15px;
  color: ${props => (props.color ? props.color : COLORS.BLACK)};
  word-spacing:0.2em;
`

const YearsOfExpFilter = ({ setCandidateRating, candidateRating,maxWorkExperience }) => {
  const [minValue, setMinValue] = useState(0)
  const [maxValue, setMaxValue] = useState(Math.ceil(maxWorkExperience))
  const onMinValueChange = val => {
    setMinValue(val)
     setCandidateRating({ minValue: val, maxValue })
  }
  const onMaxValueChange = val => {
    setMaxValue(val)
     setCandidateRating({ minValue: minValue, maxValue: val })
  }
  useEffect(() => {
    setCandidateRating({ minValue: minValue, maxValue: maxValue })
  }, [minValue, maxValue])
  return (
    <>
      <StyledHeadingNew>Years Of Experience</StyledHeadingNew>
      <StyledHeading color={COLORS.BLACK_WHITE_B_50}>
        {minValue} - {maxValue}
      </StyledHeading>

      <YOEPercentageRangeSlider
        minValue={minValue}
        setMinValue={onMinValueChange}
        maxValue={maxValue}
        setMaxValue={onMaxValueChange}
        maxWorkExperience={maxWorkExperience}
      />
    </>
  )
}

export default YearsOfExpFilter
